import { environment } from '../../../environments/environment';

export class Files {
  constructor(init: Partial<Files>) {
    Object.assign(this, init);
    if (!this.fileUrl) {
      this.fileUrl = environment.apiCadastroSettings.url +
                   environment.apiCadastroSettings.downloadInvestorDocumentUpload +
                   this.fileName;
    }
  }

  fileUrl?: string;
  fileName?: string;
  fileType?: string;
  isDeleted?: boolean;
  documentDate?: string;
}

export class FileUpload {
  file: File;
}
